/**
 * The drill bank's words about who holds a drill (#1159 slice 2, board
 * CoachDrillBank). Pure, so the unit test can pin every count.
 */

/** "A", "A and B", "A, B and C". */
export function joinNames(names) {
  if (names.length <= 1) return names.join("");
  return `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;
}

/**
 * The line under a drill: "Not assigned yet", "Assigned to A",
 * "Assigned to A and 1 other" (S5, D301: the planner's recommendation, the
 * board draws no two-holder case) or "Assigned to A and N others".
 */
export function holdersLine(holders) {
  if (holders.length === 0) return "Not assigned yet";
  const first = holders[0].full_name;
  if (holders.length === 1) return `Assigned to ${first}`;
  const rest = holders.length - 1;
  return `Assigned to ${first} and ${rest} ${rest === 1 ? "other" : "others"}`;
}

/** Holders in the roster's order (D278 keeps the server's order for the roster). */
export function inRosterOrder(holders, roster) {
  const at = (h) => roster.findIndex((p) => p.player_id === h.player_id);
  return [...holders].sort((a, b) => at(a) - at(b));
}
